import React from 'react';

const AuthorBadge = ({ type, name, role, avatar, className = '' }) => {
    const isAI = type === 'ai';

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <div className="relative">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center overflow-hidden border-2 ${isAI ? 'border-purple-200 bg-purple-50' : 'border-gray-100 bg-gray-50'}`}>
                    {avatar ? (
                        <img src={avatar} alt={name} className="w-full h-full object-cover" />
                    ) : (
                        <span className="text-lg">{isAI ? '🤖' : '✍️'}</span>
                    )}
                </div>
                {isAI && (
                    <div className="absolute -bottom-1 -right-1 bg-purple-600 text-white text-[8px] font-black px-1 rounded-sm border border-white uppercase">
                        AI
                    </div>
                )}
            </div>
            <div>
                <div className="flex items-center gap-1.5">
                    <span className="text-sm font-bold text-[#222425]">{name}</span>
                    {!isAI && <span className="text-[#00DA76] text-xs">✓</span>}
                </div>
                <div className="text-[11px] text-gray-500 font-medium">{role}</div>
            </div>
        </div>
    );
};

export default AuthorBadge;
